// components/CameraMonitor.js
import { useEffect, useRef } from 'react';

const CameraMonitor = ({ onCameraLost }) => {
  const streamRef = useRef(null);

  useEffect(() => {
    let checkInterval;

    const monitorCamera = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ 
          video: true 
        });
        streamRef.current = stream;

        // Check camera status periodically
        checkInterval = setInterval(() => {
          const video = document.getElementById('camera-feed');
          if (video) {
            video.srcObject = stream;
          }

          // Check if camera is still active
          const tracks = stream.getVideoTracks();
          if (tracks.length === 0 || tracks[0].readyState !== 'live') {
            onCameraLost();
          }
        }, 1000);

      } catch (error) {
        console.error('Camera monitoring error:', error);
        onCameraLost();
      }
    };

    monitorCamera();

    return () => {
      if (checkInterval) {
        clearInterval(checkInterval);
      }
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(track => track.stop());
      }
    };
  }, [onCameraLost]);

  return null;
};

export default CameraMonitor;